import { createContext } from 'react';

import type { ICouponState } from './coupon.interfaces';
import { initialState } from './coupon.state';

const CouponContext = createContext<ICouponState>(initialState);

CouponContext.displayName = 'Product Bundle Coupon';

export default CouponContext;
